<script>
import Banner from 'dashboard/components/ui/Banner.vue';
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

export default {
  components: { Banner },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
    bannerMessage() {
      return this.$t('APP_GLOBAL.EMAIL_VERIFICATION_PENDING');
    },
    actionButtonMessage() {
      return this.$t('APP_GLOBAL.RESEND_VERIFICATION_MAIL');
    },
    shouldShowBanner() {
      // O estado inicial do store (auth.js) nao tem a chave `confirmed`, entao
      // `!undefined` era `true` e a faixa nascia ligada em TODO carregamento,
      // apagando so quando o /profile respondia. Normalmente isso e rapido
      // demais para se ver; quando o perfil demora -- que e exatamente o que
      // acontece num refresh durante queda/reconexao -- o usuario ve a faixa
      // dizendo que o e-mail dele nao foi verificado, o que quase sempre e
      // mentira (2.840 dos 2.841 usuarios da producao estao confirmados).
      //
      // Exigir o `id` faz a faixa so opinar depois que existe um usuario
      // carregado de verdade.
      return Boolean(this.currentUser.id) && !this.currentUser.confirmed;
    },
  },
  methods: {
    resendVerificationEmail() {
      this.$store.dispatch('resendConfirmation');
      useAlert(this.$t('APP_GLOBAL.EMAIL_VERIFICATION_SENT'));
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Banner
    v-if="shouldShowBanner"
    color-scheme="alert"
    :banner-message="bannerMessage"
    :action-button-label="actionButtonMessage"
    action-button-icon="i-lucide-mail"
    has-action-button
    @primary-action="resendVerificationEmail"
  />
</template>
